








































































































































































































import { Vue, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { stAccountApi, stPaymentApi } from '@/services/st-api';
import { AccountInvoiceDataEditModel, ContractDataViewModel, LicenseDataViewModel } from '@/services/api/nswag/stapiclient_generated';
//@ts-ignore
import * as FileSaver from 'file-saver';
import * as stripe from '@stripe/stripe-js';
import { notifySuccess } from '@/utlitities/notifications';
import { UserStore } from "@/store/user-module";

@Component({
  components: {},
})
export default class PaymentSetup extends Vue {
  private contractData: ContractDataViewModel = ContractDataViewModel.fromJS({ invoiceData: {}, licenseData: {}, paymentData: {}, invoices: [] });
  private licenseData: LicenseDataViewModel = LicenseDataViewModel.fromJS({});

  private s: stripe.Stripe | null = null;
  private elements!: stripe.StripeElements;
  private numberOfLicenses: number = 0;
  private numberOfLicensesBasic: number = 0;

  loading: boolean = true;
  step: number = 1;
  paymentInterval: string = 'monthly';
  step3Loading = false;

  chooseLoading = false;
  submitLoading = false;

  @Watch('step')
  async stepChanged() {
    if (this.step == 3) {
      this.step3Loading = true;
      let publicKey = await stPaymentApi.getStripePublicKey();

      this.s = await stripe.loadStripe(publicKey);
      let clientSecret = await stPaymentApi.createSetupIntent();

      const options: stripe.StripeElementsOptions = {
        clientSecret: clientSecret,
      };

      this.elements = (this.s as stripe.Stripe).elements(options);
      const paymentElement = this.elements.create('payment');
      paymentElement.mount('#payment-element');
      this.step3Loading = false;
    }
  }

  async loadData() {
    this.contractData = await stAccountApi.getContractData();
    this.licenseData = await stAccountApi.getLicenseDataViewModel();

    if (!this.contractData.invoiceData?.paymentCountry) {
      this.contractData.invoiceData!.paymentCountry = 'Deutschland';
    }

    this.numberOfLicenses = this.licenseData.minUserCount!;
    this.numberOfLicensesBasic = this.licenseData.minUserCountBasic!;
    this.loading = false;
  }

  get amount() {
    return this.numberOfLicenses * this.licenseData.basePriceCent! + this.numberOfLicensesBasic * this.licenseData.basePriceCentBasic!;
  }

  get amountYearly() {
    return this.amountYearlyMonthly * 12;
  }

  get amountYearlyMonthly() {
    return this.numberOfLicenses * this.licenseData.basePriceCentYearly! + this.numberOfLicensesBasic * this.licenseData.basePriceCentYearlyBasic!;
  }

  get savingsYearly() {
    return this.amount * 12 - this.amountYearly;
  }

  get invoiceData(): AccountInvoiceDataEditModel {
    return this.contractData.invoiceData!;
  }

  get usePassiveUsers(){
    return UserStore.userSettings.featureFlagPassiveUsers;
  }

  get showBasicUserInputs(){
    return (UserStore.userSettings.featureFlagPassiveUsers || UserStore.userSettings.featureFlagMixedUsers) && !UserStore.userSettings.useBasicTimeTracking
  }

  checkNumberOfLicenses() {
    if (this.numberOfLicenses < this.licenseData.minUserCount!) {
      this.numberOfLicenses = this.licenseData.minUserCount!;
    }
  }

  checkNumberOfLicensesBasic() {
    if (this.numberOfLicensesBasic < this.licenseData.minUserCountBasic!) {
      this.numberOfLicensesBasic = this.licenseData.minUserCountBasic!;
    }
  }

  async mounted() {
    try {
      this.loading = true;
      await this.loadData();
    } finally {
      this.loading = false;
    }
  }

  async choose(type: string) {
    try {
      this.chooseLoading = true;
      this.paymentInterval = type;
      this.licenseData.paymentInterval = type;
      this.licenseData.userCount = this.numberOfLicenses;
      this.licenseData.userCountBasic = this.numberOfLicensesBasic;
      await stAccountApi.saveLicenseData(this.licenseData);
      this.step = 2;
    } finally {
      this.chooseLoading = false;
    }
  }

  get countries(): any[] {
    const countries = ['Deutschland', 'Österreich', 'Schweiz', 'Dänemark'];
    return countries.map((_) => {
      return { value: _, description: _ };
    });
  }

  async submit() {
    try {
      this.submitLoading = true;
      await stAccountApi.saveAccountInvoiceDataEditModel(this.invoiceData);

      notifySuccess('Erfolgreich gespeichert');
      this.step = 3;
    } finally {
      this.submitLoading = false;
    }
  }

  confirming = false;
  async confirm() {
    let elem = this.elements;
    this.confirming = true;
    const { error } = await (this.s as stripe.Stripe).confirmSetup({
      //`Elements` instance that was used to create the Payment Element
      elements: this.elements,
      confirmParams: {
        return_url: window.location.origin + '/paymentdone',
      },
    });

    this.confirming = false;

    if (error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (e.g., payment
      // details incomplete)
      const messageContainer: Element = document.querySelector('#error-message') as Element;
      messageContainer.textContent = error.message as string;
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  }
}
